import { Select, SelectItem } from '@heroui/react';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useFetchFrequenciesQuery } from '@/slices/frequency-api-slice.ts';
import type { FrequencyModel } from '../types/account-category.type.ts';
import type { FormControlProps } from '../types/form-props.type.ts';

interface FrequencySelectProps extends FormControlProps {
  description?: string;
}

export const FrequencySelect: FC<FrequencySelectProps> = ({
  name,
  label = 'Frequency',
  displayProperty = 'description',
  description,
  disabled,
  required,
}) => {
  const { data, isLoading } = useFetchFrequenciesQuery();
  const { control } = useFormContext();
  const frequencies = data ?? [];

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? 'This field is required' : undefined }}
      render={({ field, fieldState }) => (
        <Select
          label={label}
          placeholder={`Select ${label}`}
          description={description}
          variant='bordered'
          isRequired={required}
          isDisabled={disabled || isLoading}
          isInvalid={fieldState.invalid}
          errorMessage={fieldState.error?.message}
          selectedKeys={field.value?.id ? new Set([String(field.value.id)]) : new Set([])}
          items={frequencies}
          onSelectionChange={keys => {
            const selectedId = Array.from(keys)[0];
            if (!selectedId) {
              field.onChange(null);
              return;
            }

            field.onChange(frequencies.find(x => x.id === parseInt(selectedId as string, 10)));
          }}
        >
          {(item: FrequencyModel) => (
            <SelectItem key={item.id.toString()} textValue={String(item[displayProperty])}>
              {item[displayProperty]}
            </SelectItem>
          )}
        </Select>
      )}
    />
  );
};
